import omit from 'lodash/omit';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const loadsCountingByStatusQueryAtom = createQueryAtomFactory(
  'customerPortal.loadsCountingByStatus',
  () => ({
    loadStatusCounts: {
      shipped: true,
      received: true,
      reconciled: true,
    },
  }),
  {
    select: ({ loadStatusCounts }) => omit(loadStatusCounts, ['__typename']),
  },
);
